import React from 'react';
import { CheckIcon, FlameIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { trackInitiateCheckout } from '../utils/metaPixel';
import { checkoutUrl, productBrand, productEdition } from '../data/offer';
const assurances = ['7-day guarantee', 'Secure payment', 'Instant access'];
export function FinalCta() {
  return <section className="border-t border-border bg-surface py-16 sm:py-20" aria-labelledby="final-title" data-id="element-61" data-mp="15bsp5nr0okn9">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-62" data-mp="1jbahue7foi1w">
        <h2 id="final-title" className="text-balance text-3xl font-bold tracking-tight text-foreground sm:text-4xl" data-id="element-63" data-mp="1eetqzc8unpl4">
          <span className="inline-flex items-center gap-2" data-id="element-64" data-mp="1t1mznynv5x4c">
            <FlameIcon className="h-8 w-8 shrink-0 text-primary" aria-hidden="true" data-id="element-65" data-mp="1o43nd4aq7uf1" /> {productBrand}
          </span>
          <span className="mt-2 block text-xl font-semibold text-primary sm:text-2xl" data-id="element-66" data-mp="222uxkfmgwvxw">
            {productEdition}
          </span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg leading-relaxed text-muted" data-id="element-67" data-mp="1x2gm0nlnr3v4">
          Created for cement plant, concrete laboratory, construction and quality professionals worldwide.
        </p>

        <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" onClick={trackInitiateCheckout} arrow className="mt-8 w-full sm:w-auto" data-id="element-68" data-mp="s6s0y5kg81e1">
          Get my professional edition now
        </Button>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm font-medium text-muted" data-id="element-69" data-mp="120imp2p6xxq1">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-70" data-mp="1b31kh8e4dk5f">
              <CheckIcon className="h-4 w-4 text-primary" aria-hidden="true" data-id="element-71" data-mp="1fu9x0daqxlmt" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}